import { render, staticRenderFns } from "./UiCollapsible.vue?vue&type=template&id=f96454a0"
import script from "./UiCollapsible.vue?vue&type=script&lang=js"
export * from "./UiCollapsible.vue?vue&type=script&lang=js"
import style0 from "./UiCollapsible.vue?vue&type=style&index=0&id=f96454a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports